<script>
  import Modal from "../../components/Modal.svelte";
  import ChartPosts from "./ChartPosts.svelte";

  let { profile, formatNumber, data, chartDateLabels } = $props();

  let showPostsModal = $state(false);

  function openPostsModal() {
    showPostsModal = true;
  }
</script>

<div class="bg-white shadow rounded-lg p-3 sm:p-6">
  <div class="flex justify-between items-start">
    <div>
      <p class="text-xs sm:text-sm font-medium text-gray-500">Total Posts</p>
      <h3 class="text-xl sm:text-3xl font-bold text-gray-900 mt-1">
        {formatNumber(profile.posts_count)}
      </h3>
    </div>
    <div class="bg-blue-100 p-1.5 sm:p-2 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 sm:h-6 sm:w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    </div>
  </div>
  <div class="mt-1 sm:mt-2 flex items-center justify-end">
    <button
      onclick={openPostsModal}
      class="cursor-pointer text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center"
    >
      See More
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-3 w-3 ml-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>

<Modal
  open={showPostsModal}
  title="Posts Count Growth"
  size="5xl"
  closed={() => (showPostsModal = false)}
>
  {#snippet content()}
    <div class="space-y-4">
      <div class="flex items-center">
        <div
          class="flex-shrink-0 bg-gradient-to-r from-blue-400 to-blue-600 p-3 rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <div class="ml-5">
          <h3 class="text-xl font-bold text-gray-900">
            Current Posts: <span class="text-blue-600"
              >{formatNumber(profile.posts_count)}</span
            >
          </h3>
        </div>
      </div>

      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-blue-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              Monitor posting frequency and content growth to understand
              publishing patterns and account activity over time.
            </p>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <ChartPosts {data} {chartDateLabels} isInModal={true} />
      </div>
    </div>
  {/snippet}
</Modal>
